import type { CompRef } from '@wix/document-services-types';
import type { EditorAPI } from '#packages/editorAPI';
import { hoc } from '#packages/util';
import { utils as sectionsUtils } from '#packages/sections';
import type { Dispatch, MapDispatchToProps } from 'types/redux';
import type {
  WixelEditorPanelDispatchProps,
  WixelEditorPanelOwnProps,
} from './wixelEditorPanel';

const getEditorAPI = (
  dispatch: unknown,
  getState: unknown,
  { editorAPI }: { editorAPI: EditorAPI },
): EditorAPI => editorAPI;

export const mapDispatchToProps: MapDispatchToProps<
  WixelEditorPanelDispatchProps,
  WixelEditorPanelOwnProps
> = (dispatch: Dispatch, { panelName }: WixelEditorPanelOwnProps) => {
  const editorAPI: EditorAPI = dispatch(getEditorAPI);

  return {
    closePanel: () => {
      editorAPI.panelManager.closePanelByName(panelName);
    },
    selectComponentByExternalId: (externalId: string) => {
      const compRef = { id: externalId, type: 'DESKTOP' } as CompRef;

      const pageRef = editorAPI.components.getPage(compRef);
      if (!pageRef) return;

      editorAPI.pages.navigateTo(pageRef.id, () => {
        sectionsUtils.scrollToComponent(editorAPI, compRef);
        editorAPI.selection.selectComponentByCompRef(compRef);
      });
    },
  };
};

export const connectWixelEditorPanel = hoc.connect(
  hoc.STORES.EDITOR_API,
  null,
  mapDispatchToProps,
);
